import React, { Component } from 'react';
const firebase = window.firebase;




class Localization extends Component {


	changeColor = () => {

		//this.props.;

	}
	
	render() {
		return (
			<div className="container">
				<div style={
					{
						width: '100px',
						height: '100px',
						backgroundColor: 'red'
					}
				} />
				<button onClick={this.changeColor}>color</button>
			</div>
		)
	}
}

export default Localization;


// WEBPACK FOOTER //
// ./src/Localization.js